import { render, staticRenderFns } from "./DroneResultPage.vue?vue&type=template&id=6daea98e&scoped=true&"
import script from "./DroneResultPage.vue?vue&type=script&lang=js&"
export * from "./DroneResultPage.vue?vue&type=script&lang=js&"
import style0 from "./DroneResultPage.vue?vue&type=style&index=0&id=6daea98e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daea98e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VImg,VSimpleTable})
